export default __webpack_public_path__ + "static/media/skovstykket-floorplans-apartment-3-rooms.1140c778.jpg";